import styled from "styled-components";

const H2 = styled.h2`
  font-size: 3.75rem;
  letter-spacing: -1.2px;
  font-weight: 300;
  line-height: 1;
`

export default H2